import { Box, Stack } from "@mui/material";
import { CbhIcon, Illustration, Text, Title } from "@src/appV2/redesign/system/ui-components";
import { isRebrandingEnabled } from "@src/appV2/redesign/system/ui-theme";

import { HomeIndicator } from "../../components/HomeIndicator";
import { SlideTextContainer } from "../../components/SlideTextContainer";

function DocumentApprovedCard() {
  return (
    <Box
      sx={{
        width: 248,
        backgroundColor: "background.tertiary",
        border: "0.378px solid",
        borderColor: "border.primary",
        borderRadius: "21px",
        display: "flex",
        flexDirection: "column",
        padding: "10.581px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          height: 50,
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "26.5px",
            height: "26.5px",
            borderRadius: "66px",
            backgroundColor: "background.tertiary",
            border: "0.378px solid",
            borderColor: "border.primary",
            boxShadow: "0px 2.645px 15.872px rgba(0, 0, 0, 0.04)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "5.3px",
          }}
        >
          <CbhIcon type="close" size="xSmall" />
        </Box>
      </Box>

      <Stack spacing="15.872px" alignItems="center" sx={{ padding: "0 10.581px" }}>
        <Box
          sx={{
            width: 116,
            height: 79,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Illustration type="document-approved-small" sx={{ width: 79, height: 79 }} />
        </Box>

        <Stack spacing="11.144px" alignItems="center">
          <Text
            sx={{
              fontSize: "26.453px",
              fontWeight: 400,
              lineHeight: "31.744px",
              letterSpacing: "-0.2645px",
              color: "text.primary",
              textAlign: "center",
              width: 227,
            }}
          >
            Your document is approved
          </Text>
          <Text
            sx={{
              fontSize: "11.144px",
              fontWeight: 500,
              lineHeight: "11.841px",
              letterSpacing: "-0.1114px",
              color: "text.secondary",
              textAlign: "center",
              width: 194,
            }}
          >
            You can now proceed to booking shifts!
          </Text>
        </Stack>
      </Stack>

      <Box
        sx={{
          padding: "10.581px",
          paddingTop: "15.872px",
          paddingBottom: "0",
          width: "100%",
          marginTop: "37px",
        }}
      >
        <Box
          sx={{
            backgroundColor: "primary.main",
            borderRadius: "66px",
            padding: "10.581px 15.872px",
            boxShadow: "0px 2.645px 15.872px rgba(0, 0, 0, 0.04)",
            textAlign: "center",
          }}
        >
          <Text
            sx={{
              fontSize: "10.58px",
              fontWeight: 500,
              lineHeight: "11.243px",
              letterSpacing: "-0.1058px",
              color: "common.white",
            }}
          >
            Continue
          </Text>
        </Box>

        <HomeIndicator />
      </Box>
    </Box>
  );
}

export function UploadDocumentsSlide() {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 58,
          position: "relative",
          overflow: "hidden",
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            height: 388,
            "@media (max-height: 740px)": { zoom: 0.85 },
            "@media (max-height: 670px)": { zoom: 0.75 },
          }}
        >
          <DocumentApprovedCard />
        </Box>
        <Box
          sx={(theme) => ({
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "50%",
            // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
            background: `linear-gradient(to bottom, transparent 0%, transparent 36%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 75%)`,
            pointerEvents: "none",
          })}
        />
      </Box>

      <SlideTextContainer>
        <Stack spacing={0} alignItems="center" sx={{ margin: 0 }}>
          <Title variant="h3" component="h1" sx={{ textAlign: "center", margin: 0 }}>
            Upload your documents
          </Title>
          <Title variant="h3" component="h2" sx={{ textAlign: "center", margin: 0 }}>
            to access shift bookings
          </Title>
        </Stack>
      </SlideTextContainer>
    </Box>
  );
}
